module.exports = __webpack_public_path__ + "static/media/sopasycremas.f3549b4b.svg";